module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJBAMAAAASvxsjAAAAFVBMVEVUXGZUXGYAAABUXGZUXGZUXGZUXGacVjIWAAAABnRSTlMf3wC9Pz7DugWDAAAAL0lEQVQI12NgZlJiZmAwE1AQM2BgTAxMZGBQEEsTUGBQcksLUoCwgeKOiVA1EPUAs4gGnep1baUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_close_hover (1).png
// module id = X6Js
// module chunks = 9